import moment from "moment-timezone";
import i18next from "i18next";
import languageService from "./language-service";

export default class StringHelpers {
  static readonly DefaultTimeZone: string = "America/Toronto";

  static readonly UserTimeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone;

  static readonly NB_OF_SECONDS_IN_A_DAY = 86400;
  static readonly NB_OF_SECONDS_IN_AN_HOUR = 3600;
  static readonly NB_OF_SECONDS_IN_A_MINUTE = 60;

  static formatDateTime(date: Date, timeZone: string): string | null {
    if (!date) {
      return "";
    }

    //console.log("TimeZone: " + timeZone);

    var dec = moment(date);
    const formattedDate = dec.tz(timeZone).format("YYYY/MM/DD HH:mm");

    return formattedDate;
  }

  static formatDuration(seconds: number): string {
    if (!seconds) {
      return "";
    }

    const duration = moment.duration(seconds, "seconds");
    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();
    let val = "";

    if (days > 0){
      val += `${days} ${i18next.t("common.day")}`;
      val = `${this.pluralize(days, val)} `;
    } 

    if (hours > 0){
      val += `${hours} ${i18next.t("common.hour")}`;
      val = `${this.pluralize(hours, val)} `;
    } 

    if (minutes > 0){
      val += `${minutes}${i18next.t("common.min")}`;
    } 

    return val.trim();
  }

  static pluralize(count: number, textSingular: string): string {
    return textSingular + (count > 1 ? "s" : "");
  }

  static getFullName(firstname: string | undefined, lastname: string | undefined): string {
    if (firstname && lastname) {
      return firstname + " " + lastname;
    }

    if (firstname) {
      return firstname;
    }

    if (lastname) {
      return lastname;
    }
    return "";
  }

  static isStringOnlyNumbers(stringToVerify: string): boolean {
    let regexp = new RegExp("^[0-9]*$"),
    test = regexp.test(stringToVerify);
    
    return test;
  } 
  static formatNumberToTimeLeftString(nbOfSeconds: number): string {
    const days = Math.trunc(nbOfSeconds / this.NB_OF_SECONDS_IN_A_DAY);
    const hours = Math.trunc((nbOfSeconds % this.NB_OF_SECONDS_IN_A_DAY) / this.NB_OF_SECONDS_IN_AN_HOUR);
    const minutes = Math.trunc((nbOfSeconds % this.NB_OF_SECONDS_IN_AN_HOUR) / this.NB_OF_SECONDS_IN_A_MINUTE);
    const seconds = Math.trunc(nbOfSeconds % this.NB_OF_SECONDS_IN_A_MINUTE);

    let dateTime = "";

    if (days > 0) {
      dateTime = `${Math.max(days, 0)}${i18next.t("common.day")}${days > 1 ? "s" : ""} `;
    }
    if (hours > 0) {
      dateTime += `${Math.max(hours, 0)}${i18next.t("common.hour-symbol")} `;
    }
    dateTime += `${Math.max(minutes, 0).toString().padStart(2, "0")}${i18next.t("common.min")} `;
    dateTime += `${Math.max(seconds, 0).toString().padStart(2, "0")}${i18next.t("common.sec")}`;

    return dateTime;
  }

  static getEmailRegExp(): RegExp {
    // eslint-disable-next-line
    return /^(?:[a-zA-Z0-9.!#$%&amp;'*+\=?^_`{|}~-]+)(?:[\.a-zA-Z0-9!#$%&amp;'*+\=?^_`{|}~-]*)@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]+$/;
  }

  static timeSince(date: Date): string {
    return moment(date, undefined, languageService.language).fromNow();
  }

  static formatNumber(value: number, digits: number): string {
    return value.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: digits,
      useGrouping: false,
    });
  }

  static formatPrice(amount: number, digits: number = 2): string {
    return amount.toLocaleString("en-US", {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
      useGrouping: true,
    });
  }

  static formatDateEightChar(date: Date, timeZone: string): string {
    if (!date) {
      return "";
    }

    var dec = moment(date);

    return dec.tz(timeZone).format("YYYYMMDD");
  }

  static toDateString(date: Date, timeZone: string = StringHelpers.DefaultTimeZone) {
    return moment(date).tz(timeZone).format("YYYY-MM-DD");
  }

  static toHourString(date: Date, timeZone: string = StringHelpers.DefaultTimeZone) {
    return moment(date).tz(timeZone).format("hh:mm A");
  }
}
